export const readStoredAuthUser = () => {
  try {
    const rawUser = localStorage.getItem('user');
    return rawUser ? JSON.parse(rawUser) : null;
  } catch (_) {
    localStorage.removeItem('user');
    return null;
  }
};

const readUrlShopId = () => (
  typeof window !== 'undefined'
    ? new URLSearchParams(window.location.search).get('shopId')
    : null
);

export const resolveUserShopId = (user = null, fallbackUser = null) => (
  user?.shop_id ||
  user?.shopId ||
  user?.salon?.id ||
  user?.salon_id ||
  fallbackUser?.shop_id ||
  fallbackUser?.shopId ||
  fallbackUser?.salon?.id ||
  fallbackUser?.salon_id ||
  readUrlShopId() ||
  null
);

export const normalizeTenantUser = (user, fallbackUser = null) => {
  if (!user) return null;

  const normalizedUser = {
    ...(fallbackUser || {}),
    ...user,
  };

  const resolvedShopId = resolveUserShopId(user, fallbackUser);
  if (resolvedShopId) {
    normalizedUser.shop_id = resolvedShopId;
  }

  if (!normalizedUser.salon && fallbackUser?.salon) {
    normalizedUser.salon = fallbackUser.salon;
  }

  return normalizedUser;
};

export const buildShopScopedPath = (path, shopId) => {
  if (!shopId) return path;

  const [pathname, queryString = ''] = path.split('?');
  const params = new URLSearchParams(queryString);
  params.set('shop_id', String(shopId));

  return `${pathname}?${params.toString()}`;
};

export const withShopIdPayload = (payload = {}, shopId) => {
  if (!shopId) return payload;
  return { ...payload, shop_id: shopId };
};

export const appendShopIdToFormData = (formData, shopId) => {
  if (!formData || !shopId) return formData;
  formData.set('shop_id', String(shopId));
  return formData;
};
